import React from 'react';
import Header from './components/Header';
import Footer from './components/Footer';
import Body from './components/Body';

import Container from './components/Container';

const Layout = ({ children, role }) => {
  return (
    <Container>
      <Header role={role} />
      <Body>{children}</Body>
      <Footer />
    </Container>
  );
};

export default Layout;
